const VariableAccordion = ({
    title,
    variables = [],
    onInsert,
}) => {

    return (
        <div>

            {title}

        </div>
    );

};

export default VariableAccordion;